export class TriggerInvitationModal {
    constructor(root, urlParams) {
        this.root = root;
        this.urlParams = urlParams;
        this.init();
    }

    init() {
        this.logError();
        this.getUrlsParams(this.urlParams);
    }

    logError() {
        if (!this.root.hasAttribute('data-toggle')) {
            return Hop.logError('Your root element is not a modal trigger. You need to call this module on a [data-toggle="modal"] element');
        }
    }

    getUrlsParams(urlParams) {
        if (urlParams.has('invitationModalOpen')) {
            this.triggerRootClick();
        }
    }

    triggerRootClick() {
        $(this.root).trigger('click');
    }
}

Hop.defineModule('trigger-invitation-modal', (root) => {
    const url = new URL(window.location.href);
    const urlParams = url.searchParams;

    new TriggerInvitationModal(root, urlParams);
});
